import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";

import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { pharmacyDashboardAPI, pharmacyDashboardOrdersAPI } from "../../api/pahrmacy";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from "../../components/Component";
import { Button, Col, Row } from "reactstrap";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "bootstrap/dist/css/bootstrap.min.css";

const UserOrder = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useLogout();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(25);
    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: true,
            tableLoading: true,
            cardData: [],
            orderData: [],
            salesData: [],
            orders: [],
            customerData: [],
            storeStats: [],
            limit: 25,
            totalPages: 1,


            mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [onSearch, setonSearch] = useState(false);
    const [onSearchText, setSearchText] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    const isLoading = watch("isLoading");
    const tableLoading = watch("tableLoading");
    const orderData = watch("orderData");
    const salesData = watch("salesData");
    const storeStats = watch("storeStats");
    const orders = watch("orders");
    const limit = watch("limit");
    const customerData = watch("customerData");
    const cardData = watch("cardData");
    const role = localStorage.getItem("role")

    const userId = localStorage.getItem("userId");
    const totalPages = watch("totalPages");

 
  
    const getOrders = (body) => {
        pharmacyDashboardOrdersAPI(body)
            .then((res) => {
                if (res.data.status === true) {
                    const apiData = res?.data?.data;

                    setValue("limit", apiData?.totalOrders); // total count
                    setValue("orderData", apiData?.orders);  // ✅ ONLY orders array
                    setValue("totalPages", apiData?.totalPages); // ✅ ADD THIS
                    setValue("currentPage", apiData?.page); // optional sync

                    setValue("tableLoading", false);
                }
            })
            .catch(() => setValue("tableLoading", false));
    };
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(onSearchText);
        }, 500); // 500ms debounce delay

        return () => {
            clearTimeout(handler);
        };
    }, [onSearchText]);
    useEffect(() => {
        const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            //  pharmacyId:userId=="null"?"":userId,
        };

        getOrders(body);
    }, [debouncedSearch, currentPage, itemPerPage]);
    const onOrderClick = (item) => {
        const body = {
            orderId: item?.id,
            userId: item?.userId,
        };
        navigate("/order-details", { state: body });
    };
 

    const renderSparkline = (values, color) => {
        const max = Math.max(...values);
        const min = Math.min(...values);

        const points = values
            .map((v, i) => {
                const x = (i / (values.length - 1)) * 100;
                const y = 30 - ((v - min) / (max - min || 1)) * 30;
                return `${x},${y}`;
            })
            .join(" ");

        return (
            <svg width="90" height="30" viewBox="0 0 100 30">
                <polyline fill="none" stroke={`var(--bs-${color})`} strokeWidth="2" points={points} />
            </svg>
        );
    };


    const KPICardSkeleton = () => (
        <div className="col-xl-3 col-md-6">
            <div className="card shadow-sm h-100 p-3">
                <div className="card-body d-flex justify-content-between align-items-center">
                    {/* Left content */}
                    <div>
                        {/* Title */}
                        <Skeleton height={12} width={90} className="mb-2" />

                        {/* Value row */}
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <Skeleton height={15} width={110} />
                            <Skeleton height={15} width={80} />
                        </div>

                        {/* Trend text */}
                        <Skeleton height={12} width={130} />
                    </div>
                </div>
            </div>
        </div>
    );

    const RecentOrdersSkeleton = ({ rows = 6 }) => {
        return (
            <div className="card card-bordered">
                {/* Header */}
                <div className="card-inner d-flex justify-content-between align-items-center">
                    <Skeleton width={150} height={22} />
                    <div className="d-flex gap-3">
                        <Skeleton width={24} height={24} circle />
                        <Skeleton width={24} height={24} circle />
                    </div>
                </div>

                {/* Table */}
                <div className="nk-tb-list is-separate">
                    {/* Table Head */}
                    <div className="nk-tb-item nk-tb-head">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div className="nk-tb-col" key={i}>
                                <Skeleton width={80} height={14} />
                            </div>
                        ))}
                    </div>

                    {/* Rows */}
                    {Array.from({ length: rows }).map((_, idx) => (
                        <div className="nk-tb-item" key={idx}>
                            {/* Order No */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Customer */}
                            <div className="nk-tb-col">
                                <div className="d-flex align-items-center gap-2">
                                    <Skeleton width={36} height={36} circle />
                                    <Skeleton width={120} height={14} />
                                </div>
                            </div>

                            {/* Date */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Amount */}
                            <div className="nk-tb-col">
                                <Skeleton width={60} height={14} />
                            </div>

                            {/* Address */}
                            <div className="nk-tb-col">
                                <Skeleton width={180} height={14} />
                            </div>

                            {/* Purchased */}
                            <div className="nk-tb-col">
                                <Skeleton width={70} height={14} />
                            </div>

                            {/* Pharmacy */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Status */}
                            <div className="nk-tb-col">
                                <Skeleton width={70} height={14} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <>
            <Head title={"Orders List"} />
            <Content>
                <BlockHead size={`sm`} className="mb-0 pb-0">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                {"Order List"}
                            </BlockTitle>
                        </BlockHeadContent>
                        {/* <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/pharmacy-list");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent> */}
                    </BlockBetween>
                </BlockHead>
                <Block className="pt-0">
                    <div className=" my-3">
                        {/* <div className="row g-3">
              {isLoading
                ? Array(4)
                    .fill(0)
                    .map((_, i) => <KPICardSkeleton key={i} />)
                : cardData.map((item, index) => (
                    <div className="col-xl-3 col-md-6" key={index}>
                      <div className="card shadow-sm h-100 p-3" style={{backgroundColor:item?.backgroundColor}}>
                        <div className="card-body d-flex justify-content-between align-items-center">
                          <div>
                            <div className="text-white small mb-2">{item.title}</div>

                            <h3 className="fw-semibold text-white mb-2">{item.value}</h3>

                            <div className={`small fw-medium text-${item.trend === "up" ? "success" : "warning"}`}>
                              {item.trend === "up" ? "↑" : "↓"} {item.percentage}% vs. last week
                            </div>
                          </div>

                          {renderSparkline(item.spark, item.color)}
                        </div>
                      </div>
                    </div>
                  ))}
            </div> */}
                    </div>
                    <Row className="g-gs">
                        {/* <Col xxl="4" md="6">
              {isLoading ? <MiddleCardSkeleton height={120} /> : <TotalSales data={salesData} isLoading={isLoading} />}
            </Col> */}

                        {/* <Col xxl="4" md="6">
              {isLoading ? (
                <MiddleCardStatic height={120} />
              ) : (
                <StoreStatistics data={storeStats} isLoading={isLoading} />
              )}
            </Col> */}

                        <Col xxl="4" md="6">
                            <Row className="g-gs">
                                {/* <Col xxl="12" md="6">
              {isLoading ? <MiddleCardOrder height={100} /> : <Orders data={orders} isLoading={isLoading} />}
            </Col> */}

                                {/* <Col xxl="12" md="6">
              {isLoading ? <MiddleCardOrder height={100} /> : <Customer data={customerData} isLoading={isLoading} />}
            </Col> */}
                            </Row>
                        </Col>

                        <Col xxl="12">
                            {tableLoading ? (
                                <RecentOrdersSkeleton rows={6} />
                            ) : (
                                <RecentOrders
                                    title={"Orders"}
                                    setSearchText={setSearchText}
                                    onSearchText={onSearchText}
                                    onSearch={onSearch}
                                    setonSearch={setonSearch}
                                    data={orderData}
                                    limit={limit}
                                    setItemPerPage={setItemPerPage}
                                    itemPerPage={itemPerPage}
                                    paginate={paginate}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    isLoading={tableLoading}
                                    onOrderClick={onOrderClick}
                                    noPagination={false}
                                    // noPagination
                                    admin
                                />
                            )}
                        </Col>
                    </Row>
                </Block>
            </Content>
        </>
    );
};

export default UserOrder;
